<template>
    <v-dialog v-model="dialog" width="600px">
        <v-card>
            <v-card-title class="ma-2 justify-center">Add a discount rule</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-2"><b>{{ akcd.akcd_oms }}</b></v-card-text>
            <v-divider></v-divider>
            <v-card-text>            
                <v-row no-gutters>  
                    <v-col cols="6" class="px-2">
                        <v-menu v-model="akpr_verb_van_datMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" readonly offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="akpr_verb_van_dat" label="Stay from" v-on="on" clearable hint="Only enter a date when applicable"></v-text-field>
                            </template>
                            <v-date-picker v-model="akpr_verb_van_dat" :first-day-of-week="1" @input="akpr_verb_van_datMenu = false"></v-date-picker>
                        </v-menu>  
                    </v-col> 
                    <v-col cols="6" class="px-2">
                        <v-menu v-model="akpr_verb_tm_datMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" readonly offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="akpr_verb_tm_dat" label="Stay until" v-on="on" clearable hint="Only enter a date when applicable"></v-text-field>
                            </template>
                            <v-date-picker v-model="akpr_verb_tm_dat" :first-day-of-week="1" @input="akpr_verb_tm_datMenu = false"></v-date-picker>
                        </v-menu>  
                    </v-col> 
                </v-row>
                <v-row no-gutters>  
                    <v-col cols="6" class="px-2">
                        <v-menu v-model="akpr_boek_van_datMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" readonly offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="akpr_boek_van_dat" label="Booking date from" v-on="on" clearable hint="Only enter a date when applicable"></v-text-field>
                            </template>
                            <v-date-picker v-model="akpr_boek_van_dat" :first-day-of-week="1" @input="akpr_boek_van_datMenu = false"></v-date-picker>
                        </v-menu>  
                    </v-col> 
                    <v-col cols="6" class="px-2">
                        <v-menu v-model="akpr_boek_tm_datMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" readonly offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="akpr_boek_tm_dat" label="Booking date until" v-on="on" clearable hint="Only enter a date when applicable"></v-text-field>
                            </template>
                            <v-date-picker v-model="akpr_boek_tm_dat" :first-day-of-week="1" @input="akpr_boek_tm_datMenu = false"></v-date-picker>
                        </v-menu>  
                    </v-col> 
                </v-row>  

     <!-- <v-row no-gutters>
       <v-col class="px-2">
         <v-text-field v-model="akcd.akpr_advb_van" label="Number of days before stay from" type="number"  hint="Only enter a number when applicable"></v-text-field>
       </v-col> 
       <v-col class="px-2">
         <v-text-field v-model="akcd.akpr_advb_tm" label="Number of days before stay until" type="number"  hint="Only enter a number when applicable"></v-text-field>
       </v-col>   
     </v-row>   

     <v-row no-gutters>
      <v-col class="px-2">  
         <v-select v-model="akcd.akpr_aant_nacht_van" :items="nacht_nrKeuzes" item-value="nacht_nr" item-text="nacht_oms" label="Stay - Number of nights from" dense></v-select>
      </v-col>
      <v-col class="px-2">  
         <v-select v-model="akcd.akpr_aant_nacht_tm" :items="nacht_nrKeuzes" item-value="nacht_nr" item-text="nacht_oms" label="Stay - Number of nights until" dense></v-select>
      </v-col>      
     </v-row>    

     <v-row no-gutters>
      <v-col class="px-2">  
         <v-select v-model="akcd.akpr_dag_van" :items="dag_nrKeuzes" item-value="dag_nr" item-text="dag_oms" label="Arrival day" dense></v-select>
      </v-col>
      <v-col class="px-2">  
         <v-select v-model="akcd.akpr_dag_tm" :items="dag_nrKeuzes" item-value="dag_nr" item-text="dag_oms" label="Departure day" dense></v-select>
      </v-col>      
     </v-row>     
 -->
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary mx-2" small @click="addAkpr">Save</v-btn>
                <v-btn color="primary"      small @click="dialog = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data() { 
            return {
                dialog: false,

                akpr_verb_van_datMenu: "",
                akpr_verb_tm_datMenu: "",
                akpr_boek_van_datMenu: "",
                akpr_boek_tm_datMenu: "",

                akpr_verb_van_dat: "",
                akpr_verb_tm_dat: "",
                akpr_boek_van_dat: "",
                akpr_boek_tm_dat: "",

                akpr: {},
                akcd: {}

                // nacht_nrKeuzes: [],
                // dag_nrKeuzes: [],
            }
        },
        methods: {
            openDialog(akcd, akpr) {
                this.akcd = akcd;
                this.akpr = akpr;

                this.akpr_verb_van_datMenu = "";
                this.akpr_verb_tm_datMenu = "";
                this.akpr_boek_van_datMenu = "";
                this.akpr_boek_tm_datMenu = "";

                this.akpr_verb_van_dat = "";
                this.akpr_verb_tm_dat = "";
                this.akpr_boek_van_dat = "";
                this.akpr_boek_tm_dat = "";
                
                this.dialog = true;
            },
            addAkpr() { 
                this.$axios.post("ares/json/ares/syst/ref/akcd/addAkprv2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addAkprv2"
                    },
                    addAkprv2: {
                        akcd_encrid: this.akcd.akcd_encrid,
                        akpr_verb_van_dat: this.akpr_verb_van_dat,
                        akpr_verb_tm_dat: this.akpr_verb_tm_dat,
                        akpr_boek_van_dat: this.akpr_boek_van_dat,
                        akpr_boek_tm_dat: this.akpr_boek_tm_dat
                        // akpr_advb_van: parseInt(this.akpr_advb_van),
                        // akpr_advb_tm: parseInt(this.akpr_advb_tm),
                        // akpr_aant_nacht_van: parseInt(this.akpr_nacht_aant_van),
                        // akpr_aant_nacht_tm: parseInt(this.akpr_nacht_aant_tm),
                        // akpr_dag_van: parseInt(this.akpr_dag_van),
                        // akpr_dag_tm: parseInt(this.akpr_dag_tm)
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        }); 
                    } else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.addAkprv2.text,
                            color: res.data.addAkprv2.color
                        }); 
                        if (res.data.addAkprv2.color == "success") {
                            console.log(res.data.addAkprv2)
                            this.$emit("addedAkpr", res.data.addAkprv2)
                            //this.$router.reload('/syst/ref/akcd/searchAkcd/');  
                            this.dialog = false; 
                        }
                    }
                })
            }
        }
    }
</script>

